import { Chip, SxProps, ChipProps } from '@mui/material';
import OverflowTooltip from '@shared/components/ui/OverflowTooltip';
import { FC } from 'react';

interface UtmsChipProps extends ChipProps {
    overflowSx?: SxProps;
}

const UtmsChip: FC<UtmsChipProps> = ({ label, overflowSx, ...props }) => {
    return (
        <Chip
            {...props}
            size="small"
            sx={{
                fontSize: '0.813rem',
                lineHeight: '138.462%',
                letterSpacing: '0.16px',
                p: '3px 4px',
                '& .MuiChip-label': {
                    p: '0 6px',
                },
                ...props.sx,
            }}
            disabled={props.disabled}
            label={
                <OverflowTooltip sx={overflowSx} title={label}>
                    {label}
                </OverflowTooltip>
            }
            {...props}
        />
    );
};

export default UtmsChip;
